import { render, staticRenderFns } from "./orderWxSend.vue?vue&type=template&id=e99e3ff0&scoped=true"
import script from "./orderWxSend.vue?vue&type=script&lang=js"
export * from "./orderWxSend.vue?vue&type=script&lang=js"
import style0 from "./orderWxSend.vue?vue&type=style&index=0&id=e99e3ff0&prod&scoped=true&lang=css"
import style1 from "./orderWxSend.vue?vue&type=style&index=1&id=e99e3ff0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99e3ff0",
  null
  
)

export default component.exports